import { useContext } from 'react'
import { contractsTravelContext } from '../../../pages/cestovko/contracts'
import { TravelSearchForm } from './TravelSearchForm'

export const ContractsTravelSearch = () => {
  const { updateFilter, filter } = useContext(contractsTravelContext)

  return (
    <TravelSearchForm
      filter={filter}
      onSubmit={updateFilter}
      listType='contracted'
    />
  )
}
